import React, { useEffect, useState } from "react";
import { Tabs } from "@pd/pd-ui-kit";
import { useHistory } from "react-router-dom";

import Wrapper from "~/shared/ui/Wrapper";
import {
  useURLParamsGetter,
  useURLParamsSetter,
} from "~/hooks/useURLParamsSetter";

import CarSummary from "./CarSummary";
import PeopleSummary from "./PeopleSummary";

import styles from "./IvideonDealerSummary.less";

const IvideonDealerSummary2 = () => {
  const history = useHistory();

  const setURLParams = useURLParamsSetter();
  const { selected } = useURLParamsGetter<{
    selected: "cars" | "people" | undefined;
  }>();

  useEffect(() => {
    if (!selected) {
      setURLParams({ selected: "people" });
    }
  }, [selected]);

  const items = [
    { key: "people", label: "по людям", children: <PeopleSummary /> },
    { key: "cars", label: "по автомобилям", children: <CarSummary /> },
  ];

  const handlePageAnalytica = (key: string) => {
    setURLParams({ selected: key });
  };

  const goToIvideonRegistry = () => {
    history.push("/ivideon/dealers");
  };

  return (
    <Wrapper.Content
      title="Сводка"
      txtBtn="Назад"
      goBackHandler={goToIvideonRegistry}
      titleWrapperClassName={styles.titleStyle}
    >
      {selected && (
        <Tabs
          className={styles.tabs}
          items={items}
          defaultActiveKey={selected}
          onChange={handlePageAnalytica}
        />
      )}
    </Wrapper.Content>
  );
};
export default IvideonDealerSummary2;
